module.exports = __webpack_public_path__ + "img/public/AdminIcons/searchSettings.svg?72a80daf";